// import styles from "./Styles/Root.module.scss";
// import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
// import { useContext, useState, useEffect, useRef } from "react";
// import { MainContext } from "../App";
// import logo from "./assets/logo1.png";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faMagnifyingGlass,
//   faUser,
//   faAddressCard,
//   faCalculator,
//   faBars,
//   faXmark,
//   faCrown,
// } from "@fortawesome/free-solid-svg-icons";
// import UseScrollToTop from "./Hooks/useScrollsToTheTop";
// import Filter from "./Finding/Filter";
// import Footer from "./Footer";
// import userStateManager, { User } from "./AppWriteOAuth/UserStateManager";
// import CookiesBanner from "./CookiesBanner/CookiesBanner";
// import PromotionalBanner from "./VIP/PromotionalBanner";
// import AdBanner from "./Advertisement/AdBanner";

// function Root() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   UseScrollToTop();
//   const context = useContext(MainContext);

//   const [user, setUser] = useState<User | null>(
//     userStateManager.getCurrentUser()
//   );

//   const isUserValid = (user: User | null): boolean => {
//     return (
//       user !== null &&
//       user.external_Id !== null &&
//       user.external_Id !== "" &&
//       user.external_Id !== "null" &&
//       user.first_name !== null &&
//       user.first_name !== "" &&
//       user.first_name !== "null" &&
//       user.user_type !== "unknown"
//     );
//   };

//   const {
//     menuBar,
//     setMenuBar,
//     selectedNavigation,
//     setSelectedNavigation,
//     setSearchByCity,
//     setSearchByDistrict,
//     setSearchByProfession,
//     setSearchByVerification,
//     setSearchByExperience,
//     setSearchByPriceFrom,
//     setSearchByPriceUpTo,
//     setTitleForCategory,
//     scrolled,
//     setScrolled,
//   } = context;

//   const isMounted = useRef(true);

//   useEffect(() => {
//     isMounted.current = true;

//     const initializeAuth = async () => {
//       const currentUser = userStateManager.getCurrentUser();

//       if (currentUser) {
//         setUser(currentUser);

//         // ✅ Google და Facebook users-ს არ ვამოწმებთ JWT-ს
//         if (
//           currentUser.user_type !== "clientOfGoogle" && 
//           currentUser.user_type !== "clientOfFacebook"
//         ) {
//           userStateManager.startTokenValidationCheck();
//         } else if (currentUser.user_type === "clientOfGoogle") {
//           // Google მომხმარებლისთვის შევამოწმოთ AppWrite-ის სესია
//           try {
//             const { getCurrentUser: getAppWriteUser } = await import(
//               "./AppWriteOAuth/AppWrite"
//             );
//             const appWriteUser = await getAppWriteUser();
//             if (!appWriteUser) {
//               userStateManager.clearUser();
//             }
//           } catch (error) {
//             console.error("AppWrite session check failed:", error);
//           }
//         }
//         // ✅ Facebook users-ს არაფერი არ სჭირდება (მხოლოდ localStorage)
//       } else {
//         // თუ localStorage-ში არ არის მომხმარებელი, ვამოწმებთ cookies-ებს
//         const isAuthenticated = await userStateManager.checkAuthStatus();

//         if (isAuthenticated) {
//           setUser(userStateManager.getCurrentUser());
//         }
//       }
//     };

//     initializeAuth();

//     const userChangeListener = (updatedUser: User | null) => {
//       if (isMounted.current) {
//         setUser(updatedUser);
//       }
//     };

//     userStateManager.addListener(userChangeListener);

//     const handleScroll = () => {
//       const scrollPosition = window.scrollY;
//       if (scrollPosition > 50) {
//         setScrolled(true);
//       } else {
//         setScrolled(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       isMounted.current = false;
//       userStateManager.removeListener(userChangeListener);
//       window.removeEventListener("scroll", handleScroll);
//       userStateManager.stopTokenValidationCheck();
//     };
//   }, []);

//   // ✅ ეფექტი, რომელიც იმუშავებს ყოველი ნავიგაციისას
//   useEffect(() => {
//     const checkAuth = async () => {
//       const currentUser = userStateManager.getCurrentUser();

//       // ✅ მხოლოდ JWT მომხმარებლებისთვის ვამოწმებთ ავთენტიფიკაციას
//       if (
//         currentUser && 
//         currentUser.user_type !== "clientOfGoogle" && 
//         currentUser.user_type !== "clientOfFacebook"  // ← ეს დაამატე
//       ) {
//         await userStateManager.checkAuthStatus();
//       }
//     };

//     checkAuth();
//   }, [location.pathname]);

//   useEffect(() => {
//     const path = location.pathname;
//     if (path === "/") {
//       setSelectedNavigation("home");
//     } else if (path.includes("calculator")) {
//       setSelectedNavigation("calculator");
//     } else if (path.includes("search")) {
//       setSelectedNavigation("search");
//     } else if (path.includes("registration")) {
//       setSelectedNavigation("registration");
//     } else if (path.includes("authorization")) {
//       setSelectedNavigation("authorization");
//     }
//   }, [location]);

//   const handleNavigation = (nav: string) => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//     setSelectedNavigation(nav);
//     setMenuBar(false);
//     setSearchByCity("");
//     setSearchByDistrict("");
//     setSearchByProfession("");
//     setSearchByVerification("");
//     setSearchByExperience("");
//     setSearchByPriceFrom("");
//     setSearchByPriceUpTo("");
//     setTitleForCategory("");
//   };

//   const handleLogin = async () => {
//     if (user?.user_type === "client") {
//       navigate(`/client/personal-page/${user.external_Id}`);
//     } else if (user?.user_type === "clientOfGoogle") {
//       navigate(`/google-account`);
//     } else if (user?.user_type === "clientOfFacebook") {
//       navigate(`/fb-account`);
//     } else {
//       navigate(`/craftsman/personal-page/${user?.external_Id}`);
//     }
//     setMenuBar(false);
//   };

//   const toggleMenu = () => {
//     setTimeout(() => {
//       setMenuBar(!menuBar);
//     }, 50);
//   };

//   const MenuLink = ({
//     to,
//     iconComponent,
//     text,
//     isSelected,
//     onClick,
//   }: {
//     to: string;
//     iconComponent: React.ReactNode;
//     text: string;
//     isSelected: boolean;
//     onClick: () => void;
//   }) => (
//     <Link
//       to={to}
//       className={`${styles.navElement} ${
//         isSelected ? styles.selectedNavElement : ""
//       }`}
//       onClick={onClick}
//     >
//       {iconComponent}
//       <span>{text}</span>
//     </Link>
//   );

//   return (
//     <>
//       <div className={styles.parentContainer}>
//         <div
//           className={`${styles.navContainer} ${
//             scrolled ? styles.scrolled : ""
//           }`}
//         >
//           <nav className={styles.nav}>
//             <div className={styles.logoContainer}>
//               <Link
//                 to="/"
//                 onClick={() => {
//                   handleNavigation("home");
//                 }}
//               >
//                 <img src={logo} alt="logo" className={styles.logoImg} />
//               </Link>

//               <div className={styles.logoContainer__menuBarIcon}>
//                 {!menuBar ? (
//                   <div>
//                     <FontAwesomeIcon
//                       icon={faBars}
//                       className={styles.faBars}
//                       onClick={toggleMenu}
//                       aria-label="მენიუს გახსნა"
//                       aria-expanded="false"
//                     />
//                   </div>
//                 ) : (
//                   <FontAwesomeIcon
//                     icon={faXmark}
//                     className={styles.faXmark}
//                     onClick={toggleMenu}
//                     aria-label="მენიუს დახურვა"
//                     aria-expanded="true"
//                   />
//                 )}
//               </div>
//             </div>

//             <div
//               className={
//                 menuBar ? styles.mobileNavigation : styles.desktopNavigation
//               }
//               aria-expanded={menuBar}
//               role="navigation"
//             >
//               <MenuLink
//                 to="/vipmanager"
//                 iconComponent={
//                   <FontAwesomeIcon icon={faCrown} className={styles.faCrown} />
//                 }
//                 text="VIP პაკეტები"
//                 isSelected={selectedNavigation === "vipmanager"}
//                 onClick={() => handleNavigation("vipmanager")}
//               />

//               <MenuLink
//                 to="/calculator"
//                 iconComponent={
//                   <FontAwesomeIcon
//                     icon={faCalculator}
//                     className={styles.faCalculator}
//                   />
//                 }
//                 text="კალკულატორი"
//                 isSelected={selectedNavigation === "calculator"}
//                 onClick={() => handleNavigation("calculator")}
//               />

//               <MenuLink
//                 to="/search"
//                 iconComponent={
//                   <FontAwesomeIcon
//                     icon={faMagnifyingGlass}
//                     className={styles.faMagnifyingGlass}
//                   />
//                 }
//                 text="დეტალური ძებნა"
//                 isSelected={selectedNavigation === "search"}
//                 onClick={() => handleNavigation("search")}
//               />

//               <MenuLink
//                 to="/registration"
//                 iconComponent={
//                   <FontAwesomeIcon
//                     icon={faAddressCard}
//                     className={styles.faAddressCard}
//                   />
//                 }
//                 text="რეგისტრაცია"
//                 isSelected={selectedNavigation === "registration"}
//                 onClick={() => handleNavigation("registration")}
//               />

//               {isUserValid(user) ? (
//                 <div className={styles.isAuthorized} onClick={handleLogin}>
//                   <img
//                     src={user?.profile_img}
//                     alt={user?.first_name}
//                     className={styles.isAuthorized__userImg}
//                   />
//                   <p>{user?.first_name}</p>
//                 </div>
//               ) : (
//                 <MenuLink
//                   to="/authorization"
//                   iconComponent={
//                     <FontAwesomeIcon icon={faUser} className={styles.faUser} />
//                   }
//                   text="შესვლა"
//                   isSelected={selectedNavigation === "authorization"}
//                   onClick={() => handleNavigation("authorization")}
//                 />
//               )}
//             </div>
//           </nav>
//         </div>

//         <Filter />
//         <CookiesBanner />
//         <PromotionalBanner />
//         <AdBanner/>
//         <div className={styles.outlet}>
//           <div className={styles.outletInCenter}>
//             <Outlet />
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// }

// export default Root;









////////////////////
// Root.tsx - განახლებული ვერსია notification badge-ით

import styles from "./Styles/Root.module.scss";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useContext, useState, useEffect, useRef } from "react";
import { MainContext } from "../App";
import logo from "./assets/logo1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faUser,
  faAddressCard,
  faCalculator,
  faBars,
  faXmark,
  faCrown,
} from "@fortawesome/free-solid-svg-icons";
import UseScrollToTop from "./Hooks/useScrollsToTheTop";
import Filter from "./Finding/Filter";
import Footer from "./Footer";
import userStateManager, { User } from "./AppWriteOAuth/UserStateManager";
import CookiesBanner from "./CookiesBanner/CookiesBanner";
import PromotionalBanner from "./VIP/PromotionalBanner";
import AdBanner from "./Advertisement/AdBanner";
// ✅ Import notification components
import { useNotifications } from "./Hooks/useNotifications";
import NotificationBadge from "./Notifications/NotificationBadge";

function Root() {
  const navigate = useNavigate();
  const location = useLocation();
  UseScrollToTop();
  const context = useContext(MainContext);

  const [user, setUser] = useState<User | null>(
    userStateManager.getCurrentUser()
  );

  // ✅ Add notification hook
  const { unreadCount, markAsRead } = useNotifications(user?.user_type || null);

  const isUserValid = (user: User | null): boolean => {
    return (
      user !== null &&
      user.external_Id !== null &&
      user.external_Id !== "" &&
      user.external_Id !== "null" &&
      user.first_name !== null &&
      user.first_name !== "" &&
      user.first_name !== "null" &&
      user.user_type !== "unknown"
    );
  };

  const {
    menuBar,
    setMenuBar,
    selectedNavigation,
    setSelectedNavigation,
    setSearchByCity,
    setSearchByDistrict,
    setSearchByProfession,
    setSearchByVerification,
    setSearchByExperience,
    setSearchByPriceFrom,
    setSearchByPriceUpTo,
    setTitleForCategory,
    scrolled,
    setScrolled,
  } = context;

  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;

    const initializeAuth = async () => {
      const currentUser = userStateManager.getCurrentUser();

      if (currentUser) {
        setUser(currentUser);

        // ✅ Google და Facebook users-ს არ ვამოწმებთ JWT-ს
        if (
          currentUser.user_type !== "clientOfGoogle" && 
          currentUser.user_type !== "clientOfFacebook"
        ) {
          userStateManager.startTokenValidationCheck();
        } else if (currentUser.user_type === "clientOfGoogle") {
          // Google მომხმარებლისთვის შევამოწმოთ AppWrite-ის სესია
          try {
            const { getCurrentUser: getAppWriteUser } = await import(
              "./AppWriteOAuth/AppWrite"
            );
            const appWriteUser = await getAppWriteUser();
            if (!appWriteUser) {
              userStateManager.clearUser();
            }
          } catch (error) {
            console.error("AppWrite session check failed:", error);
          }
        }
        // ✅ Facebook users-ს არაფერი არ სჭირდება (მხოლოდ localStorage)
      } else {
        // თუ localStorage-ში არ არის მომხმარებელი, ვამოწმებთ cookies-ებს
        const isAuthenticated = await userStateManager.checkAuthStatus();

        if (isAuthenticated) {
          setUser(userStateManager.getCurrentUser());
        }
      }
    };

    initializeAuth();

    const userChangeListener = (updatedUser: User | null) => {
      if (isMounted.current) {
        setUser(updatedUser);
      }
    };

    userStateManager.addListener(userChangeListener);

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      isMounted.current = false;
      userStateManager.removeListener(userChangeListener);
      window.removeEventListener("scroll", handleScroll);
      userStateManager.stopTokenValidationCheck();
    };
  }, []);

  // ✅ ეფექტი, რომელიც იმუშავებს ყოველი ნავიგაციისას
  useEffect(() => {
    const checkAuth = async () => {
      const currentUser = userStateManager.getCurrentUser();

      // ✅ მხოლოდ JWT მომხმარებლებისთვის ვამოწმებთ ავთენტიფიკაციას
      if (
        currentUser && 
        currentUser.user_type !== "clientOfGoogle" && 
        currentUser.user_type !== "clientOfFacebook"
      ) {
        await userStateManager.checkAuthStatus();
      }
    };

    checkAuth();
  }, [location.pathname]);

  useEffect(() => {
    const path = location.pathname;
    if (path === "/") {
      setSelectedNavigation("home");
    } else if (path.includes("calculator")) {
      setSelectedNavigation("calculator");
    } else if (path.includes("search")) {
      setSelectedNavigation("search");
    } else if (path.includes("registration")) {
      setSelectedNavigation("registration");
    } else if (path.includes("authorization")) {
      setSelectedNavigation("authorization");
    }
  }, [location]);

  const handleNavigation = (nav: string) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setSelectedNavigation(nav);
    setMenuBar(false);
    setSearchByCity("");
    setSearchByDistrict("");
    setSearchByProfession("");
    setSearchByVerification("");
    setSearchByExperience("");
    setSearchByPriceFrom("");
    setSearchByPriceUpTo("");
    setTitleForCategory("");
  };

  const handleLogin = async () => {
    // ✅ Mark notifications as read when user clicks profile
    await markAsRead();

    if (user?.user_type === "client") {
      navigate(`/client/personal-page/${user.external_Id}`);
    } else if (user?.user_type === "clientOfGoogle") {
      navigate(`/google-account`);
    } else if (user?.user_type === "clientOfFacebook") {
      navigate(`/fb-account`);
    } else {
      navigate(`/craftsman/personal-page/${user?.external_Id}`);
    }
    setMenuBar(false);
  };

  const toggleMenu = () => {
    setTimeout(() => {
      setMenuBar(!menuBar);
    }, 50);
  };

  const MenuLink = ({
    to,
    iconComponent,
    text,
    isSelected,
    onClick,
  }: {
    to: string;
    iconComponent: React.ReactNode;
    text: string;
    isSelected: boolean;
    onClick: () => void;
  }) => (
    <Link
      to={to}
      className={`${styles.navElement} ${
        isSelected ? styles.selectedNavElement : ""
      }`}
      onClick={onClick}
    >
      {iconComponent}
      <span>{text}</span>
    </Link>
  );

  return (
    <>
      <div className={styles.parentContainer}>
        <div
          className={`${styles.navContainer} ${
            scrolled ? styles.scrolled : ""
          }`}
        >
          <nav className={styles.nav}>
            <div className={styles.logoContainer}>
              <Link
                to="/"
                onClick={() => {
                  handleNavigation("home");
                }}
              >
                <img src={logo} alt="logo" className={styles.logoImg} />
              </Link>

              <div className={styles.logoContainer__menuBarIcon}>
                {!menuBar ? (
                  <div>
                    <FontAwesomeIcon
                      icon={faBars}
                      className={styles.faBars}
                      onClick={toggleMenu}
                      aria-label="მენიუს გახსნა"
                      aria-expanded="false"
                    />
                  </div>
                ) : (
                  <FontAwesomeIcon
                    icon={faXmark}
                    className={styles.faXmark}
                    onClick={toggleMenu}
                    aria-label="მენიუს დახურვა"
                    aria-expanded="true"
                  />
                )}
              </div>
            </div>

            <div
              className={
                menuBar ? styles.mobileNavigation : styles.desktopNavigation
              }
              aria-expanded={menuBar}
              role="navigation"
            >
              <MenuLink
                to="/vipmanager"
                iconComponent={
                  <FontAwesomeIcon icon={faCrown} className={styles.faCrown} />
                }
                text="VIP პაკეტები"
                isSelected={selectedNavigation === "vipmanager"}
                onClick={() => handleNavigation("vipmanager")}
              />

              <MenuLink
                to="/calculator"
                iconComponent={
                  <FontAwesomeIcon
                    icon={faCalculator}
                    className={styles.faCalculator}
                  />
                }
                text="კალკულატორი"
                isSelected={selectedNavigation === "calculator"}
                onClick={() => handleNavigation("calculator")}
              />

              <MenuLink
                to="/search"
                iconComponent={
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className={styles.faMagnifyingGlass}
                  />
                }
                text="დეტალური ძებნა"
                isSelected={selectedNavigation === "search"}
                onClick={() => handleNavigation("search")}
              />

              <MenuLink
                to="/registration"
                iconComponent={
                  <FontAwesomeIcon
                    icon={faAddressCard}
                    className={styles.faAddressCard}
                  />
                }
                text="რეგისტრაცია"
                isSelected={selectedNavigation === "registration"}
                onClick={() => handleNavigation("registration")}
              />

              {isUserValid(user) ? (
                <div className={styles.isAuthorized} onClick={handleLogin}>
                  {/* ✅ Wrap profile image in container for badge positioning */}
                  <div className={styles.isAuthorized__userContainer}>
                    <img
                      src={user?.profile_img}
                      alt={user?.first_name}
                      className={styles.isAuthorized__userImg}
                    />
                    {/* ✅ Add notification badge */}
                    <NotificationBadge count={unreadCount} />
                  </div>
                  <p>{user?.first_name}</p>
                </div>
              ) : (
                <MenuLink
                  to="/authorization"
                  iconComponent={
                    <FontAwesomeIcon icon={faUser} className={styles.faUser} />
                  }
                  text="შესვლა"
                  isSelected={selectedNavigation === "authorization"}
                  onClick={() => handleNavigation("authorization")}
                />
              )}
            </div>
          </nav>
        </div>

        <Filter />
        <CookiesBanner />
        <PromotionalBanner />
        <AdBanner/>
        <div className={styles.outlet}>
          <div className={styles.outletInCenter}>
            <Outlet />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Root;